import { api } from "./dataService";

export const fetchAllCustomerImportSettings = async () =>
  (await api.get("data/import-customer-settings")).data;

export const fetchCustomerImportSettings = async (kunde_id) =>
  (await api.get(`data/customers/${kunde_id}/import-settings`)).data;

export const updateCustomerImportSetting = async (
  kunde_id,
  record_type,
  import_mode
) =>
  (
    await api.put(`data/customers/${kunde_id}/import-settings/${record_type}`, {
      import_mode,
    })
  ).data;
